import React from "react";
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';
import Link from "next/link";

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}

const Accountype = ({ meta, jsonLd }) => {

  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="accounttype">
        <section className="mt5trade">
          <div className="mt5cont">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 ">
                  <h1 className=" mb-3">Smart Trading Starts with the Right Account!</h1>
                  <p className=" mb-3">
                    Millance Ltd offers a range of account types, each designed to provide seamless access to global financial markets, empowering traders with the right tools for success.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <img
                    src={"/images/accountype/accountbanner1.png"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="accoun1 mt-5">
          <div className="container">
            <div className="acctype">
              <h2 className="text-center mb-3">
                Choose the Perfect Account for Your Trading Success!
              </h2>
              <p className="text-center">
                Start trading with a minimum deposit of $100 and enjoy a zero-fee policy on all transactions. Millance LTD offers a range of account options, including Standard, ECN, Elite, and Premium accounts, tailored to suit every trader&apos;s needs. Your success is our priority, which is why we ensure a seamless trading experience with no hidden bank or credit card fees.
              </p>
            </div>
          </div>
        </section>
        <section className="acctble mt-5">
          <div className="container">
            <div className="acctpri">
              <div className="row mt-5">
                <div className="col-md-12 col-lg-2">
                  <div className="accountypes">
                    <ul>
                      <li>Trading Platform</li>
                      <li>Spread</li>
                      <li>Minimum deposit</li>
                      <li>Trading Lot size</li>
                      <li>Maximum leverage</li>
                      <li>Execution</li>
                      <li>Swap Charges</li>
                      <li>Margin call</li>
                      <li>Stop out level</li>
                      <li>Personal account Manager</li>
                      <li>Account currency</li>
                      <li>Commission for forex pairs</li>
                      <li>Open Account</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-12 col-lg-10">
                  <div className="pricinglist">
                    <div className="row">
                      <div className="col-md-12 col-lg-4">
                        <div className="pricing-table gprice-single pb-4">
                          <div className="head">
                            <h5 className="title mt-3">STANDARD</h5>
                          </div>
                          <div className="content">
                            <div className="price">
                              <h6>$100</h6>
                            </div>
                            <ul>
                              <li>MT5</li>
                              <li>From 1.3 pips</li>
                              <li>$100</li>
                              <li>0.01-100Lots</li>
                              <li> Upto 1:400 </li>
                              <li> STP/ECN</li>
                              <li> YES</li>

                              <li> 50%</li>
                              <li> 30%</li>
                              <li> NO</li>
                              <li> USD</li>
                              <li>NO</li>
                            </ul>
                            <div className="sign-up">
                              <Link
                                 href="https://crm.millance.com/register"
                                className="btn bordered radius"
                              // onClick={Change}
                              >
                                OPEN LIVE ACCOUNT
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-4">
                        <div className="pricing-table gprice-single pb-4">
                          <div className="head">
                            <h5 className="title mt-3">PREMIUM</h5>
                          </div>
                          <div className="content">
                            <div className="price">
                              <h6>$1000</h6>
                            </div>
                            <ul>
                              <li>MT5</li>
                              <li>From 0.5 pips </li>
                              <li>$1000</li>
                              <li>0.01-100Lots</li>
                              <li> Upto 1:200 </li>
                              <li> STP/ECN</li>
                              <li> YES</li>

                              <li> 50%</li>
                              <li> 30%</li>
                              <li> Yes</li>
                              <li> USD</li>

                              <li>$5</li>
                            </ul>
                            <div className="sign-up">
                              <Link 
                                href="https://crm.millance.com/register"
                                className="btn bordered radius"
                              >
                                OPEN LIVE ACCOUNT
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-4">
                        <div className="pricing-table gprice-single pb-4">
                          <div className="head">
                            <h5 className="title mt-3">ELITE</h5>
                          </div>
                          <div className="content">
                            <div className="price">
                              <h6>$500</h6>
                            </div>
                            <ul>
                              <li>MT5</li>
                              <li>From 1.1 pips </li>
                              <li>$500</li>
                              <li>0.01-100Lots</li>
                              <li> Upto 1:300 </li>
                              <li> STP/ECN</li>
                              <li>YES</li>

                              <li> 50%</li>
                              <li> 30%</li>
                              <li> NO</li>
                              <li> USD</li>

                              <li> NO</li>
                            </ul>
                            <div className="sign-up">
                              <Link
                                href="https://crm.millance.com/register"
                                className="btn bordered radius"
                              >
                                OPEN LIVE ACCOUNT
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-12 col-lg-3">
                        <div className="pricing-table gprice-single pb-4">
                          <div className="head">
                            <h5 className="title mt-3">PREMIUM</h5>
                          </div>
                          <div className="content">
                            <div className="price">
                              <h6>$10000</h6>
                            </div>
                            <ul>
                              <li>MT5</li>
                              <li>From 0 pips </li>
                              <li>$10000</li>
                              <li>0.01-100Lots</li>
                              <li> Upto 1:500</li>

                              <li> STP/ECN</li>
                              <li> NO</li>

                              <li> 50%</li>
                              <li> 30%</li>
                              <li>Yes</li>
                              <li> USD</li>
                              <li> $5</li>
                            </ul>
                            <div className="sign-up">
                              <a
                                href="https://crm.millance.com/register"
                                className="btn bordered radius"
                              >
                                OPEN LIVE ACCOUNT
                              </a>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="acctype3 mt-5 ">
          <div className="container">
            <h2 className="text-center mb-3 pt-4">
              {" "}
              Select the Optimal Account for Your Trading Strategy!            </h2>
            <p className="text-center">
              Each Millance LTD account type is a universal trading tool that aids in
              working on international financial markets. When working with
              Millance LTD, you will have access to any trading symbol available,
              regardless of the account type you choose.
            </p>
            <div className="stand">
              <h5 className="mb-3">Standard Account</h5>
              <p>
                Designed for new traders, the Standard account provides seamless market execution, competitive spreads, and zero trading fees, ensuring a smooth and cost-effective trading experience.
              </p>
            </div>
            <div className="ecn mt-3">
              <h5 className="mb-3">ECN Account</h5>
              <p>
                Ideal for professionals, our ECN (Electronic Communication Network) account delivers unparalleled trading conditions, featuring ultra-fast execution, raw spreads starting from 0.0 pips, real-time price quotes, and deep liquidity from top-tier providers.
              </p>
            </div>
            <div className="premi mt-3">
              <h5 className="mb-3">Premium Account</h5>
              <p>
                Elevate your trading with our Premium account, offering advanced execution speeds, tight spreads as low as 0.0 pips, and access to a vast network of liquidity providers, ensuring precision and efficiency in every copy trade.
              </p>
            </div>
          </div>
        </div>
        <section className="fastsecure mt-5">
          <div className="fastsectrade">
            <div className="container">
              <h2 className="text-center mb-3">Fast, Secure & Hassle-Free Transactions</h2>
              <p>
                Enjoy instant and secure deposits, ensuring you&apos;re ready to copy trade within minutes. With low or zero-fee transaction options, you retain more capital for market opportunities.
              </p>
              <div className="accslider">

              </div>
              <div className="accsli1">
                <img
                  src={"/images/home/tether-ico.png"}
                  alt="logo"
                  className="img-fluid m-auto d-block"
                />
              </div>
            </div>
          </div>
        </section>
        <div className="meta5 mt-3">
          <div className="container">
            <h2 className="text-center">Meta Trader5</h2>

            <div className="row mt-4">
              <div className="col-md-12 col-lg-4">
                <div className="appdownloadicons d-flex align-items-center">
                  <div className="appicon1">
                    {" "}
                    <img
                      src={"/images/accountype/android.png"}
                      alt="logo"
                      className="img-fluid mx-3"
                    />
                  </div>
                  <div className="appicon2">
                    {" "}
                    <a
                      href="https://download.mql5.com/cdn/mobile/mt5/android?utm_source=www.metatrader5.com&utm_campaign=install.metaquotes"
                      className="dropdown-item"
                    // onClick={handleCaptureClick}
                    >
                      <p>Download For</p> <h6>Android</h6>{" "}
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4">
                <div className="appdownloadicons d-flex align-items-center">
                  <div className="appicon1">
                    {" "}
                    <img
                      src={"/images/accountype/mac.png"}
                      alt="logo"
                      className="img-fluid mx-3 ios-mobi"
                    />
                  </div>
                  <div className="appicon2">
                    <a
                      className="dropdown-item"
                      href="https://download.mql5.com/cdn/mobile/mt5/ios?utm_source=www.metatrader5.com&utm_campaign=install.metaquotes
                            "
                    >
                      <p>Available on the</p>
                      <h6>IOS</h6>
                    </a>
                  </div>
                  <div className="ios-mac-line">/</div>
                  <div className="appicon2">
                    <a
                      className="dropdown-item"
                      href="https://download.mql5.com/cdn/mobile/mt5/ios?utm_source=www.metatrader5.com&utm_campaign=install.metaquotes
                            "
                    >
                      <h6 className="ios-home">MAC</h6>
                    </a>
                  </div>
                  <div className="appicon1">
                    {" "}
                    <img
                      src={"/images/accountype/ios.png"}
                      alt="logo"
                      className="img-fluid mx-3 mac-lap "
                    />
                  </div>
                </div>
              </div>
              {/* <div className="col-md-12 col-lg-3">
                <div className="appdownloadicons d-flex align-items-center">
                  <div className="appicon1">
                    <img
                      src={"/images/accountype/mac.png"}
                      alt="logo"
                      className="img-fluid mx-3"
                    />
                  </div>
                  <div className="appicon2">
                    {" "}
                    <p>Download For</p>
                    <h6>Mac</h6>
                  </div>
                </div>
              </div> */}
              <div className="col-md-12 col-lg-4">
                <div className="appdownloadicons d-flex align-items-center">
                  <div className="appicon1">
                    <img
                      src={"/images/accountype/windows.png"}
                      alt="logo"
                      className="img-fluid mx-3 "
                    />
                  </div>
                  <div className="appicon2">
                    <a
                      className="dropdown-item"
                      /* href="https://download.mql5.com/cdn/web/19448/mt5/millance5setup.exe" */
                      download
                    >
                      {" "}
                      <p>Download For</p>
                      <h6>Windows</h6>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="getmt5 mt-5 pb-5">
          <div className="getsmt5">
            <div className="container">
              <h2 className="text-center mb-3">Get Started!</h2>
              <p className="getapara">
                Start trading anytime, anywhere with ease. Our platform is built for efficiency, security, and ease of use.
              </p>
              <div className="row mt-5 align-items-center">
                <div className="col-md-12 col-lg-9">
                  <div className="row">
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/signupicon2.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                          style={{maxWidth:'60px'}}
                        />
                        <h5 className="my-1 mb-3">Register</h5>
                        <p className="mb-0 font-13">
                          Sign up and create your trading account in minutes.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/verifyicon2.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                          style={{maxWidth: '60px'}}
                        />
                        <h5 className="my-1 mb-3">Verify</h5>
                        <p className="mb-0 font-13">
                          Upload the  r instant verificatio.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/depositicon1.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                          style={{maxWidth:'60px'}}
                        />
                        <h5 className="my-1 mb-3">Deposit</h5>
                        <p className="mb-0 font-13">
                          Fund your account with a minimum of $100.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/tradeicon1.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                          style={{maxWidth:'60px'}}
                        />
                        <h5 className="my-1 mb-3">Copy trade</h5>
                        <p className="mb-0 font-13">
                          Start trading across a range of instruments and maximize your potential!
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center getsbtn mt-5">
                      <div className="openlivebtn">
                        <Link href={'https://crm.millance.com/register'} target="_blank">
                          <button type="button" className="btn btn-primary">
                            Open Live Account
                          </button>
                        </Link>
                      </div>
                      {/* <div className="opendemobtn">
                        <a href="https://crm.millance.com/opendemoaccount">
                          <button type="button" className="btn btn-primary">
                            Open Demo Account
                          </button>
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-3">
                  <div className="getimg">
                    <img
                      src={"/images/home/getstartimg1.gif"}
                      alt="logo"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Accountype;
